import type { NextPage } from 'next';
import RefundPolicyPage from '@containers/RefundPolicy';
import Head from 'next/head';

const RefundPolicy: NextPage = () => {
  return (
    <>
      <Head>
        <title>Refund Policy | The Cumin Club</title>
      </Head>
      <RefundPolicyPage />
    </>
  );
};

export default RefundPolicy;
